<template>
    <v-row style="padding-top:10px">
        <v-toolbar class="hidden-sm-and-down" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0" class="hidden-sm-and-down">
                <v-menu content-class="menu-content" class="alturaMenu" :close-on-content-click="false"
                    :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Mis Pendientes</span>
                        </v-btn>
                    </template>



                    <v-list class="listParent" style="width: 300px !important; z-index: 65 !important; max-height: calc(100vh - 100px); overflow-y: auto;">
                        <v-list-item @click="$router.push({ name: 'Favorito' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Favoritos
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesGeneral' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Pendientes
                                General
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesContacto' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>Contacto</v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="permisoAsistenciaCivil"
                                     @click="$router.push({ name: 'MisPendientesAsistenciaCivil' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>Posible asistencia civil</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesTermino' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>Término</v-list-item-title>
                        </v-list-item>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Vehículo</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>

                                <v-list-item @click="$router.push({ name: 'MisPendientesVhdetenido' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        <p>
                                            ● Vehículo Detenido
                                        </p>
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesSolicitudDoc' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Falta Solicitud de Documentos
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesRecepcionDoc' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Falta Recepcion de
                                        Documentación
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesMontPenGrua' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Falta Montos
                                        Pensión/Multas/Grua
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesPagosPenGrua' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Falta Pagos
                                        Pensión/Multas/Grua
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-item @click="$router.push({ name: 'MisPendientesConDetenido' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>Conductor Detenido</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesPeritajeFav' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>Peritaje Favorable</v-list-item-title>
                        </v-list-item>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    Robo
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item @click="$router.push({ name: 'MisPendientesRobo' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">● Robo</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesRoboSolicitudDoc' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Falta Solicitud de
                                        Documentos
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesRoboRecepcionDoc' }).catch((error) => error);"
                                             class="listElement">

                                    <v-list-item-title class="listChildElement">
                                        ● Falta Recepción de
                                        Documentación
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    Documentos
                                </v-list-item>
                            </template>
                            <v-list>

                                <v-list-item @click="$router.push({ name: 'MisPendientesDocumentosValidar' }).catch((error) => error);"
                                             class="listElement" v-if="permisoDocPorValidar" >
                                    <v-list-item-title class="listChildElement">
                                        ● Validar
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesDocumentosRechazados' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Rechazados
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    Autorizaciones de Conclusión
                                </v-list-item>
                            </template>
                            <v-list>

                                <v-list-item @click="$router.push({ name: 'MisPendientesPendAutorizar' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Pendientes de
                                        Autorizar
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesPendSinConcluir' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Autorizadas sin
                                        Concluir
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesConRechazada' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">● No Autorizadas</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-item @click="$router.push({ name: 'MisPendientesSinVolante' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Sin Volante
                                Jurídico
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesDiasSinMov' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Días sin
                                Movimiento
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="$router.push({ name: 'MisPendientesAsuntosRelevantes' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Asuntos
                                Relevantes
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'MisPendientesLlamadasCI' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Llamadas por
                                Contacto Inteligente
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    Negociaciones
                                </v-list-item>
                            </template>
                            <v-list>

                                <v-list-item @click="$router.push({ name: 'MisPendientesPendientesCapturar' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Pendientes de
                                        Capturar
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="$router.push({ name: 'MisPendientesPendientesAutorizar' }).catch((error) => error);"
                                             class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        ● Pendientes de
                                        Autorizar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-item @click="$router.push({ name: 'MisPendientesMovDiaAnterior' }).catch((error) => error);"
                                     class="listElement">
                            <v-list-item-title>
                                Movimientos día anterior
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu content-class="menu-content" class="alturaMenu" :close-on-content-click="false"
                    :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Estadísticas</span>
                        </v-btn>
                    </template>
                    <v-list class="listParent" style="width: 300px !important; z-index:65 !important">
                        <v-list-item class="listElement" v-if="estadisticajur"
                            @click="$router.push({ name: 'Juridico' });">
                            <v-list-item-title>Jurídico</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" v-if="estadisticarlv"
                            @click="$router.push({ name: 'EstadisticaRLV' });">
                            <v-list-item-title>RLV</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" v-if="estadisticarobo"
                            @click="$router.push({ name: 'EstadisticaRobo' });">
                            <v-list-item-title>Robo</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" v-if="estadisticarcmedico"
                            @click="$router.push({ name: 'EstadisticaRCMedico' });">
                            <v-list-item-title>
                                RC
                                Medico
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item class="listElement" v-if="estadisticaCivil"
                            @click="$router.push({ name: 'EstadisticaCivil' });">
                            <v-list-item-title>
                                Civil
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item class="listElement" v-if="estadisticageneral"
                            @click="$router.push({ name: 'EstadistaGeneral' });">
                            <v-list-item-title>
                                Estadístico
                                General
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y
                    v-if="permisoIndicadores">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Indicadores</span>
                        </v-btn>
                    </template>
                    <v-list style="width: 300px !important; z-index:65 !important">
                        <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorDiario' });">
                            <v-list-item-title>Indicador Diario</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorMensual' });">
                            <v-list-item-title>Indicador Mensual</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorSupervisor' });">
                            <v-list-item-title>Indicador Supervisor</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorAnioAnterior' });">
                            <v-list-item-title>{{ indicador }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Utilidades</span>
                        </v-btn>
                    </template>
                    <v-list style="width: 300px !important; z-index:65 !important">
                        <v-list-item class="listElement" @click="$router.push({ name: 'UtilidadesBitacora' });"
                            v-if="permisoExpJur">
                            <v-list-item-title>Bitácora</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" v-if="permisoConcluidos"
                            @click="$router.push({ name: 'UtilidadesConcluidos' });">
                            <v-list-item-title>
                                Reporte
                                Concluidos
                            </v-list-item-title>
                        </v-list-item>
                        <!--<v-list-item class="listElement">
                            <v-list-item-title>WS</v-list-item-title>
                        </v-list-item>-->

                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>WS</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-group no-action>
                                    <template v-slot:activator>
                                        <v-list-item style="margin-left: -5%;">
                                            <v-list-item-title>GNP</v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list>
                                        <v-list-item @click="llamar('GNP')" class="listElement">
                                            <v-list-item-title class="listChildElement">
                                                <p>
                                                    ● Seguimiento GNP
                                                </p>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="archivo('GNP')" class="listElement">
                                            <v-list-item-title class="listChildElement">
                                                ● Archivo GNP
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                                <v-list-group no-action v-if="atlas || atlasarchivos">
                                    <template v-slot:activator>
                                        <v-list-item style="margin-left: -5%;">
                                            <v-list-item-title>Atlas</v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list>

                                        <!--<v-list-item @click="llamar('Atlas')" class="listElement">
                                            <v-list-item-title class="listChildElement">
                                                <p>
                                                    ● Información Atlas
                                                </p>
                                            </v-list-item-title>
                                        </v-list-item>-->

                                        <v-list-item @click="archivo('Atlas')" class="listElement" v-if="atlasarchivos">
                                            <v-list-item-title class="listChildElement">
                                                ● Archivos Atlas
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="$router.push({ name: 'BitacoraAtlas' });"
                                            class="listElement" v-if="atlas">
                                            <v-list-item-title class="listChildElement">
                                                ● Expediente Atlas
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                            </v-list>
                        </v-list-group>
                        <v-list-item class="listElement" v-if="permisoExpJur"
                            @click="$router.push({ name: 'CitasPendientes' });">
                            <v-list-item-title>Citas</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'ReasignacionesMasivas' });"
                            v-if="permisoReasignacion">
                            <v-list-item-title>Reasignaciones Masivas</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'BuscarProveedor' }).catch((error) => error);;"
                            class="listElement">
                            <v-list-item-title>Buscar Proveedor</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'ConsultaProductos' }).catch((error) => error);;"
                            class="listElement">
                            <v-list-item-title>Consulta de Productos</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y v-if="poderes">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Poderes</span>
                        </v-btn>
                    </template>
                    <v-list style="width: 300px !important; z-index:65 !important">
                        <v-list-item class="listElement" @click="$router.push({ name: 'altapoder' });">
                            <v-list-item-title>Alta Poder</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'BusquedaPoderes' });">
                            <v-list-item-title>
                                Búsqueda de
                                Poder
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'BusquedaEstado' });">
                            <v-list-item-title>Búsqueda Por
                                Estado</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="listElement" @click="$router.push({ name: 'ListadoPendiente' });">
                            <v-list-item-title>Pendientes</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar class="hidden-md-and-up" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0">
                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="white" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list style="width: 400px !important; z-index:65 !important">
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Mis Pendientes</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list style="margin-left: 5%; z-index: 65 !important">
                                    <v-list-item @click="$router.push({ name: 'Favorito' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>
                                            Favoritos
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="$router.push({ name: 'MisPendientesGeneral' });"
                                                 class="listElement">
                                        <v-list-item-title>
                                            Pendientes
                                            General
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="$router.push({ name: 'MisPendientesContacto' });"
                                                 class="listElement">
                                        <v-list-item-title>Contacto</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="$router.push({ name: 'MisPendientesTermino' });"
                                                 class="listElement">
                                        <v-list-item-title>Término</v-list-item-title>
                                    </v-list-item>
                                    <v-list-group no-action>
                                        <template v-slot:activator>
                                            <v-list-item style="margin-left: -5%;">
                                                <v-list-item-title>Vehículo</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesVhdetenido' });"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    <p>
                                                        ● Vehículo Detenido
                                                    </p>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesSolicitudDoc' });"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta Solicitud de Documentos
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesRecepcionDoc' });"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta
                                                    Recepcion de Documentación
                                                </v-list-item-title>
                                            </v-list-item>
                                            <!--<v-list-item @click="$router.push({ name: 'MisPendientesSolicitudDoc' });"
                         class="listElement">
                <v-list-item-title class="listChildElement">
                    ● Falta
                    Recepcion de Documentación
                </v-list-item-title>
            </v-list-item>-->
                                            <v-list-item @click="$router.push({ name: 'MisPendientesMontPenGrua' });"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta
                                                    Montos Pensión/Multas/Grua
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesPagosPenGrua' });"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta
                                                    Pagos Pensión/Multas/Grua
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-list-group>
                                    <v-list-item @click="$router.push({ name: 'MisPendientesConDetenido' });"
                                                 class="listElement">
                                        <v-list-item-title>
                                            Conductor
                                            Detenido
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="$router.push({ name: 'MisPendientesPeritajeFav' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>Peritaje Favorable</v-list-item-title>
                                    </v-list-item>
                                    <v-list-group no-action>
                                        <template v-slot:activator>
                                            <v-list-item style="margin-left: -5%;">
                                                Robo
                                            </v-list-item>
                                        </template>
                                        <v-list>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesRobo' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">● Robo</v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesRoboSolicitudDoc' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta Solicitud de
                                                    Documentos
                                                </v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesRoboRecepcionDoc' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Falta Recepcion de
                                                    Documentación
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-list-group>
                                    <v-list-group no-action>
                                        <template v-slot:activator>
                                            <v-list-item style="margin-left: -5%;">
                                                Documentos
                                            </v-list-item>
                                        </template>
                                        <v-list>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesDocumentosValidar' }).catch((error) => error);"
                                                         class="listElement" v-if="permisoDocPorValidar" >
                                                <v-list-item-title class="listChildElement" >
                                                    ● Validar
                                                </v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesDocumentosRechazados' }).catch((error) => error);"
                                                         class="listElement" >
                                                <v-list-item-title class="listChildElement">
                                                    ● Rechazados
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-list-group>
                                    <v-list-group no-action>
                                        <template v-slot:activator>
                                            <v-list-item style="margin-left: -5%;">
                                                Autorizaciones de Conclusión
                                            </v-list-item>
                                        </template>
                                        <v-list>


                                            <v-list-item @click="$router.push({ name: 'MisPendientesPendAutorizar' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Pendientes de
                                                    Autorizar
                                                </v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesPendSinConcluir' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Autorizadas sin
                                                    Concluir
                                                </v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="$router.push({ name: 'MisPendientesConRechazada' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● No
                                                    Autorizadas
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-list-group>

                                    <v-list-item @click="$router.push({ name: 'MisPendientesSinVolante' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>Sin Volante Jurídico</v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="$router.push({ name: 'MisPendientesDiasSinMov' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>Días sin Movimiento</v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="$router.push({ name: 'MisPendientesAsuntosRelevantes' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>Asuntos Relevantes</v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="$router.push({ name: 'MisPendientesLlamadasCI' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>Llamadas por Contacto Inteligente</v-list-item-title>
                                    </v-list-item>
                                    <v-list-group no-action>
                                        <template v-slot:activator>

                                            <v-list-item style="margin-left: -5%;">
                                                Negociaciones
                                            </v-list-item>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesPendientesCapturar' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Pendientes de
                                                    Capturar
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="$router.push({ name: 'MisPendientesPendientesAutorizar' }).catch((error) => error);"
                                                         class="listElement">
                                                <v-list-item-title class="listChildElement">
                                                    ● Pendientes de
                                                    Autorizar
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-list-group>
                                    <v-list-item @click="$router.push({ name: 'MisPendientesMovDiaAnterior' }).catch((error) => error);"
                                                 class="listElement">
                                        <v-list-item-title>
                                            Movimientos día anterior
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Estadísticas</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item class="listElement" v-if="estadisticajur"
                                    @click="$router.push({ name: 'Juridico' });">
                                    <v-list-item-title class="listChildElement">● Jurídico</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="estadisticarlv"
                                    @click="$router.push({ name: 'EstadisticaRLV' });">
                                    <v-list-item-title class="listChildElement">● RLV</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="estadisticarobo"
                                    @click="$router.push({ name: 'EstadisticaRobo' });">
                                    <v-list-item-title class="listChildElement">● Robo</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="estadisticarcmedico"
                                    @click="$router.push({ name: 'EstadisticaRCMedico' });">
                                    <v-list-item-title class="listChildElement">
                                        ● RC
                                        Medico
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item class="listElement" v-if="estadisticaCivil"
                                    @click="$router.push({ name: 'EstadisticaCivil' });">
                                    <v-list-item-title class="listChildElement">
                                        ● Civil
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item class="listElement">
                                    <v-list-item-title class="listChildElement"
                                        @click="$router.push({ name: 'EstadistaGeneral' });">
                                        ● Estadístico
                                        General
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action v-if="permisoIndicadores">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Indicadores</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorDiario' });">
                                    <v-list-item-title class="listChildElement">● Indicador Diario</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" @click="$router.push({ name: 'IndicadorMensual' });">
                                    <v-list-item-title class="listChildElement">● Indicador Mensual</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'IndicadorSupervisor' });">
                                    <v-list-item-title class="listChildElement">● Indicador
                                        Supervisor</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'IndicadorAnioAnterior' });">
                                    <v-list-item-title class="listChildElement">● {{ indicador }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action>
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Utilidades</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item class="listElement" @click="$router.push({ name: 'UtilidadesBitacora' });"
                                    v-if="permisoExpJur">
                                    <v-list-item-title class="listChildElement">
                                        ●
                                        Bitácora
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="permisoConcluidos"
                                    @click="$router.push({ name: 'UtilidadesConcluidos' });">
                                    <v-list-item-title class="listChildElement">
                                        ● Reporte
                                        Concluidos
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item class="listElement">
                                    <v-list-item-title class="listChildElement">● WS</v-list-item-title>
                                </v-list-item>

                                <v-list-item class="listElement" v-if="permisoExpJur"
                                    @click="$router.push({ name: 'CitasPendientes' });">
                                    <v-list-item-title class="listChildElement">● Citas</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'ReasignacionesMasivas' });">
                                    <v-list-item-title class="listChildElement">● Reasignaciones
                                        Masivas</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement">
                                    <v-list-item-title
                                        @click="$router.push({ name: 'BuscarProveedor' }).catch((error) => error);;"
                                        class="listChildElement">● Buscar Proveedor</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="$router.push({ name: 'ConsultaProductos' }).catch((error) => error);;"
                                    class="listElement">
                                    <v-list-item-title class="listChildElement">● Consulta de
                                        Productos</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                        <v-list-group no-action v-if="poderes">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Poderes</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item class="listElement" @click="$router.push({ name: 'altapoder' });">
                                    <v-list-item-title class="listChildElement">● Alto Poder</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" @click="$router.push({ name: 'BusquedaPoderes' });">
                                    <v-list-item-title class="listChildElement">● Búsqueda de Poder</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" @click="$router.push({ name: 'BusquedaEstado' });">
                                    <v-list-item-title class="listChildElement">● Búsqueda Por
                                        Estado</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" @click="$router.push({ name: 'ListadoPendiente' });">
                                    <v-list-item-title class="listChildElement">● Pendientes</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-list-group>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <!--<v-container class="hidden-md-and-up">

            <v-btn flat color="primary" @click="toggleMenu = !toggleMenu">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
        </v-container>-->
    </v-row>
</template>
<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { mapActions, mapState } from "vuex";
import Indicadores from "@/services/Operacion/Indicadores.service.js";

export default {
    data() {
        return {
            toggleMenu: false,
            groupOpened: false,
            permisoConcluidos: false,
            permisoDocPorValidar: false,
            permisoExpJur: false,
            permisoReasignacion: false,
            estadisticageneral: false,
            estadisticarlv: false,
            estadisticajur: false,
            estadisticarobo: false,
            estadisticarcmedico: false,
            estadisticaCivil: false,
            poderes: false,
            gnp: false,
            altas: false,
            permisoIndicadores: false,
            indicador: '',
            permisoAsistenciaCivil: false,
            atlas: false,
            atlasarchivos: false,
        }
    },
    methods: {
        async archivo(cliente) {
            if (cliente == 'Atlas') {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'ArchivoAtlas' });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'ArchivoGNP' });
                //window.open("https://www.ausa.com.mx/PrusiaGo/Utilidades/Archivos");
            }
        },
        async llamar(cliente) {
            if (cliente == 'Atlas') {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'SeguimientoAtlas' });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'SeguimientoGNP' });

                //window.open("https://www.ausa.com.mx/PrusiaGo/Utilidades/Seguimiento?data=UfPeFVr86xUgauPwd0nyXw==");
            }
        },
        showMenu() {
            return this.toggleMenu || this.$vuetify.breakpoint.mdAndUp
        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async mounted() {
        let permiso = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '143');
        if (permiso.data.length > 0) {
            permiso.data.forEach(per => {
                if (per.peclave == 143) //permiso indicadores
                    this.permisoIndicadores = true;
            })
        }
        let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '292,28,47,133,42,298,41,132,275,269,325, 367, 368, 373,343');
        if (response.data.length > 0) {
            response.data.forEach(permiso => {
                if (permiso.peclave == 292)//Permiso para ver concluidos
                    this.permisoConcluidos = true;
                if (permiso.peclave == 28)//Permiso para ver concluidos
                    this.permisoExpJur = true;
                if (permiso.peclave == 47)
                    this.permisoReasignacion = true
                if (permiso.peclave == 133)
                    this.estadisticageneral = true;
                if (permiso.peclave == 42)
                    this.estadisticajur = true;
                if (permiso.peclave == 298)
                    this.estadisticarobo = true;
                if (permiso.peclave == 41)
                    this.estadisticarlv = true;
                if (permiso.peclave == 132)
                    this.estadisticarcmedico = true;
                if (permiso.peclave == 275)
                    this.poderes = true;
                if (permiso.peclave == 269)
                    this.gnp = true;
                if (permiso.peclave === 367)
                    this.permisoAsistenciaCivil = true;
                if (permiso.peclave == 325)
                    this.atlas = true;
                if (permiso.peclave == 368)
                    this.atlasarchivos = true;
                if (permiso.peclave === 373)
                    this.estadisticaCivil = true;
                if (permiso.peclave === 343)
                    this.permisoDocPorValidar =true;


            });
        }
        var formData = new FormData();
        formData.append("tipo", 42);
        let resp = await Indicadores.ObtenerParametro(formData);
        this.indicador = resp.panombre
    }

}
</script>
<style scoped>
    @media (max-width: 600px) {
        .listParent {
            max-height: calc(100vh - 50px); /* Ajuste para pantallas pequeñas */
            scrollbar-width: thin; /* Ancho del scroll */
            scrollbar-color: rgba(0, 0, 0, 0.5) transparent; /* Color del scroll y del track */
        }
    }

.listChildElement {
    margin-left: 5%;
}

@media (max-height: 800px) {
    .menu-content {
        top: 145px !important;
    }
}



.listElement {
    cursor: pointer;
}

.listElement {
    margin: 2px;
    border-radius: 4px;
}

.listElement:hover {
    background: #d8f9ff;
}

.listElement:active {
    background: #d8f9ff;
}




.listChildElementMob {
    margin-left: 5%;
}

.listElementMob {
    cursor: pointer;
}

.listElementMob {
    margin: 2px;
    margin-left: 5%;
    border-radius: 4px;
}

.listElementMob:hover {
    background: #d8f9ff;
}

.listElementMob:active {
    background: #d8f9ff;
}
</style>
